import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import ConfirmAsyncActionModalContent from './ConfirmAsyncActionModalContent';
import SuccessModal from './SuccessModal';
import ErrorModal from './ErrorModal';
import assignNewPrintBatchId from '../../api/assignNewPrintBatchId';

const AssignNewPrintBatchModal = ({
  isOpen,
  onClose,
  onSuccessClose,
  orderId,
}) => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [token, setToken] = useState(null);
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    setShowSuccess(false);
    setShowError(false);
    setErrorMessage(null);
  }, [orderId]);

  useEffect(() => {
    if (isOpen) {
      const fetchToken = async () => {
        try {
          const accessToken = await getAccessTokenSilently({
            audience: window.ENV_CONFIG.auth0.audience,
          });
          setToken(accessToken);
        } catch (error) {
          setErrorMessage('Failed to authenticate. Please try again.');
          setShowError(true);
        }
      };

      fetchToken();
    }
  }, [isOpen, getAccessTokenSilently]);

  const handleConfirm = async () => {
    try {
      await assignNewPrintBatchId(token, orderId);
      setShowSuccess(true);
    } catch (e) {
      setErrorMessage(e.message || 'An error occurred');
      setShowError(true);
    }
  };
  const handleClose = () => {
    setErrorMessage(null);
    onClose();
  };
  const handleSuccessClose = () => {
    setErrorMessage(null);
    onSuccessClose();
    onClose();
  };
  const headerText = 'Confirm new print batch assignment';
  /* eslint-disable */
  const bodyText = (
    <>
      Are you sure you want to assign a new print batch ID to order <strong>{orderId}</strong>?<br /><br />Please double check this order number is correct before confirming.
    </>
  );
  /* eslint-enable */
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay>
          {!errorMessage && showSuccess && (
            <SuccessModal
              bodyText={`Order ${orderId} has been successfully assigned a new print batch ID.`}
              onClose={handleSuccessClose}
            />
          )}
          {!!errorMessage && (
            <ErrorModal error={errorMessage} onClose={handleSuccessClose} />
          )}
          {!showError && !showSuccess && (
            <ConfirmAsyncActionModalContent
              isOpen={isOpen}
              onClose={handleClose}
              asyncAction={handleConfirm}
              headerText={headerText}
              bodyText={bodyText}
            />
          )}
        </ModalOverlay>
      </Modal>
    </>
  );
};

export default AssignNewPrintBatchModal;
